<div class="dialog-panel">
  <div class="icon-close" [inlineSVG]="'/icons/icon-close.svg'" (click)="closeDialog()"></div>
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'company.create_company' | transloco }}</h1>
      </div>
      <div class="dialog-body">
        <p class="info">
          {{ 'company.create_company_info' | transloco }}
        </p>

        @for (key of order; track key) {
          <div class="form-field-container">
            @if (!(config.app === 'flixit' && key === 'photo_id')) {
              <!-- Label -->
              <div class="form-field-label" [ngClass]="{ required: isFormControlRequired(getFormControl(key)) }">
                @if (key === 'photo_id') {
                  {{ 'upload.upload_foto' | transloco }}
                } @else {
                  {{ 'form.field.' + key | transloco }}
                }
              </div>
              <!-- Label -->
              @switch (key) {
                <!-- Photo upload -->
                @case ('photo_id') {
                  <div class="row mt-2">
                    <div class="col-12 col-sm-6 col-photo align-self-center">
                      <lib-photo-upload
                        [photo]="getFormControl('photo')?.value ? getFormControl('photo').value.url1x : null"
                        (fileChange)="fileChange($event)"
                      ></lib-photo-upload>
                    </div>
                  </div>
                }
                <!-- Photo upload -->
                <!-- Country select -->
                @case ('country') {
                  <lib-select
                    [options]="countries"
                    [value]="getFormControl(key).value"
                    [errors]="getFormControl(key).errors"
                    (valueChange)="countryValueChange($event)"
                  ></lib-select>
                }
                <!-- Country select -->
                <!-- Input for all other fields -->
                @default {
                  <mat-form-field class="form-field" [floatLabel]="'auto'">
                    <input matInput [formControlName]="key" [required]="isFormControlRequired(getFormControl(key))" />
                    @if (getFormControl(key).invalid) {
                      <mat-error>
                        @if (getFormControl(key).errors.required) {
                          {{ 'form.error.required' | transloco }}
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                }
                <!-- Input for all other fields -->
              }
            }
          </div>
        }
        @if (config.app === 'films-nl') {
          <p class="mb-0">
            {{ 'company.by_signing_up' | transloco }}
            <span class="text-red text-bold cta-btn"> {{ 'company.terms_for_business' | transloco }} </span
            >{{ 'company.and' | transloco }}
            <span class="text-red text-bold cta-btn"> {{ 'company.privacy' | transloco }}</span>
          </p>
        }
      </div>
      <div class="dialog-bottom create-company">
        <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
          {{ 'global.continue' | transloco }}
        </button>
        @if (showGobackBtn) {
          <button (click)="goToLoginPage()" type="text" class="btn btn-primary d-block w-100">
            {{ 'global.go_back_to_login' | transloco }}
          </button>
        }
        @if (showGobackBtn) {
          <button (click)="goToLoginPage()" type="text" class="btn btn-primary d-block w-100">
            {{ 'global.go_back_to_login' | transloco }}
          </button>
        }
      </div>
    </form>
  </div>
</div>
